import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    ESSENTIALS_kr,
    ESSENTIALS_ca,
    ESSENTIALS_cn, // Import Chinese essentials
} from "../../components/Bulletin/constants";
import "./Footer.css";

const Attention = () => {
    const { t } = useTranslation();
    const lang = useSelector((state) => state.app.lang);

    // Determine which ESSENTIALS content to use based on the selected language
    const ESSENTIALS =
        lang === "kr"
            ? ESSENTIALS_kr
            : lang === "cn"
            ? ESSENTIALS_cn
            : ESSENTIALS_ca;

    return (
        <>
            <div className="contentContainer">
                <div className="contentTitle">{t("Attention")}</div>
                <div
                    className="explDiv"
                    dangerouslySetInnerHTML={{
                        __html: ESSENTIALS,
                    }}
                />
            </div>
        </>
    );
};

export default Attention;
